import { FormEvent, useEffect, useState } from "react"

import { UITypes } from "types"
import { ReactComponent as IconClear } from "assets/svg/icon-input-sn-clear.svg"

import { isValidDeviceSn } from "utils/isValidDeviceSn"

import { InputNew } from "../InputNew"

import styles from "./index.module.scss"

interface Props extends UITypes.InvalidDevice {
  onChange: (data: UITypes.InvalidDevice) => void
  onDelete: (id: string) => void
  onBlur: (data: UITypes.InvalidDevice) => void
  autoFocus?: boolean
}

const formatSerialNumber = (input: string): string => {
  const digitsOnly = input.replace(/\D/g, "")
  const limitedDigits = digitsOnly.slice(0, 11)

  if (limitedDigits.length === 0) {
    return ""
  }
  if (limitedDigits.length === 1) {
    return limitedDigits
  }

  let formatted = limitedDigits.replace(/^(\d{2})(\d*)$/, "$1-$2")
  if (limitedDigits.length >= 5) {
    formatted = formatted.replace(/^(\d{2}-\d{3})(\d*)$/, "$1-$2")
  }

  return formatted
}

export const InputSN = ({ uid, sn, row, errorMessage, autoFocus, onBlur, onDelete, onChange }: Props) => {
  const [value, setValue] = useState(sn)

  useEffect(() => {
    setValue(sn)
  }, [sn])

  const onInputChange = (event: FormEvent<HTMLInputElement>) => {
    const rawValue = event?.currentTarget?.value
    const formattedValue = formatSerialNumber(rawValue)
    const parsedValue = formattedValue?.replace(",", "")

    setValue(formattedValue)

    if (isValidDeviceSn(parsedValue)) {
      onBlur({
        uid,
        row,
        errorMessage,
        sn: parsedValue || "",
      })
    } else {
      onChange({
        uid,
        row,
        errorMessage: "",
        sn: formattedValue,
      })
    }
  }

  return (
    <div className={styles.inputWrapper}>
      <div className={styles.inputNumber}>{row}</div>
      <InputNew
        className={styles.inputSN}
        placeholder="Enter S/N"
        name="sn"
        autoFocus={autoFocus}
        value={value}
        onBlur={onInputChange}
        onChange={onInputChange}
        errorMessage={errorMessage}
      />
      {onDelete && (
        <span className={styles.clearButton} onClick={() => onDelete(uid)}>
          <IconClear />
        </span>
      )}
    </div>
  )
}
